<template>
  <div>
    <v-card class="mx-auto" color="#E3F2FD" height="50" max-width="700">
      <v-card-text> </v-card-text>
    </v-card>
    <v-card class="mx-auto" color="#BBDEFB" height="100" max-width="800">
      <v-card-text> </v-card-text>
    </v-card>
    <v-card
      elevation="12"
      color="#90CAF9"
      height="200"
      max-width="900"
      class="mt-n12 mx-auto"
    >
      <v-card-text>
        <v-layout justify-center align-center fill-height>
          <h1 class="font-weight black--text">
            {{ $t("WE CAN DO EVERYTHING HERE!") }}
          </h1>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>
  
  <script>
export default {};
</script>
  